<template>
  <div class="orderContainer" data-app id="book-order">
    <div v-if="active" class="overlay" @click="close"/>
    <div v-if="active" :class="{order: true, active: active, mobile: mobile()}">
      <img src="@/assets/closeIcon.svg" class="closeIcon" @click="close">
      <div class="description">
        <h3><b>Glaube für Anfänger</b> – Gratis Buchbestellung</h3>
        <p class="author">von Maria Jäger, Taschenbuch</p>
        <div class="coverContainer">

          <div class="bookText">
            <!--<p>
              Weihnachten kommt näher – und damit ein ganz besonderes Geschenk für dich. Um an es ranzukommen, müssen
              einige Schichten Verpackung abgetragen werden. Das können Vorurteile gegenüber dem Glauben sein,
              Berührungsängste oder einfach fehlende Informationen.<br><br>
              Dieses Buch holt dich bei deinen Zweifeln und
              Vorbehalten ab, erklärt dir, warum du nicht deinen Verstand ausschalten musst, um an Jesus zu glauben und
              liefert dir Stoff zum Nachdenken. Vor allem aber will dieses Buch erzählen, wie großartig Gott ist, wie
              sehr er persönlich an jedem Einzelnen interessiert ist und wie viel einem Menschen entgeht, der ihn
              verpasst …
            </p>-->

            <p>Du bist ein kritisch denkender Mensch und hast Gott aus unterschiedlichen Gründen abgeschrieben?
              <br><br>
              Dann ist dieses Buch für dich.
              <br><br>
              <i>»Glaube für Anfänger«</i> möchte zeigen, dass es sich lohnt, genauer hinzuschauen, und dass die Botschaft der
              Bibel – sofern sie wahr ist – alle etwas angeht. Argumente und Erklärungen liefern dabei Stoff zum
              Nachdenken. Vor allem aber will dieses Buch erzählen, wie großartig Gott ist, wie sehr er persönlich an
              jedem Einzelnen interessiert ist und wie viel einem Menschen entgeht, der ihn verpasst …</p>
          </div>
          <img src="@/assets/gfa_cover.jpg" class="cover">
        </div>
      </div>
      <div class="content">
        <v-btn class="modernButton orderDetailsButton" v-show="! order" @click="order = true">Jetzt bestellen</v-btn>
        <v-form v-model="formValid" class="data" v-if="order && ! submitted">
          <v-row wrap>
            <v-flex xs12 sm6>
              <v-text-field v-model="firstName" label="Vorname" :rules="[getRules().present]"/>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field v-model="lastName" label="Nachname" :rules="[getRules().present]"/>
            </v-flex>
          </v-row>
          <v-row wrap>
            <v-flex xs12>
              <v-text-field v-model="street" label="Straße, Hausnummer"
                            :rules="[getRules().present]"/>
            </v-flex>
          </v-row>
          <v-row wrap>
            <v-flex xs6 sm4>
              <v-text-field v-model="zip" label="Postleitzahl" :rules="[getRules().present]"/>
            </v-flex>
            <v-flex xs6 sm4>
              <v-text-field v-model="city" label="Ort" :rules="[getRules().present]"/>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select v-model="country" :items="countries" label="Land"
                        :rules="[getRules().required]"/>
            </v-flex>
          </v-row>
          <v-row>
            <v-flex xs12>
              <v-checkbox v-model="accepted" :rules="[getRules().checked]">
                <template slot="label">
                  <p>
                    Ja, ich möchte ein kostenloses Buch zugeschickt bekommen.
                    Meine Daten werden <b>nicht</b> an Dritte weitergegeben und <b>nur</b> zum Zweck der Abwicklung der
                    Bestellung gespeichert.
                  </p>
                </template>
              </v-checkbox>
            </v-flex>
          </v-row>
          <v-row justify="center" align="center">
            <v-flex>
              <!--<vue-recaptcha :sitekey="captchaKey" badge="bottomright"
                             loadRecaptchaScript
                             ref="recaptcha"
                             @verify="submit">
              </vue-recaptcha>
              -->
              <v-btn class="modernButton" :disabled="! isValid" @click="submit">Kostenlos bestellen</v-btn>
            </v-flex>
          </v-row>
        </v-form>
        <div v-if="submitted">
          <br>
          <p><b>Vielen Dank für Ihre Bestellung!</b><br>
            Wir werden das Buch möglichst schnell versenden, sodass es schon bald bei Ihnen ankommen
            wird!</p>
          <v-btn class="modernButton" @click="close" style="margin-top: 10px;">Zurück zur Hauptseite</v-btn>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import BasicComponent from "@/components/BasicComponent.js";
import {Prop} from "vue-property-decorator";
import InfoContent from "@/components/easter/info/InfoContent";
import VueScrollTo from "vue-scrollto";
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";

@Component({
  components: {VueRecaptcha}
})
export default class Order extends BasicComponent {

  data() {
    return {
      formValid: false,
      accepted: false,
      active: false,
      order: false,
      firstName: "",
      lastName: "",
      street: "",
      zip: "",
      city: "",
      country: null,
      countries: ["Österreich", "Deutschland"],
      error: null,
      submitted: false,
    };
  }

  mounted() {
    if (this.isFlyer) {
      this.$data.country = "Österreich";
    }
    if (this.isAdventskalender) {
      this.trackPage("Adventskalender GfA Bestellung");
    }
  }

  open() {
    this.$data.active = true;
  }

  close() {
    this.$data.active = false;
  }

  submit(token) {
    //this.$refs.recaptcha.reset();
    //if (!token) return;
    if (!this.isValid) {
      this.$data.error = "Bitte füllen Sie alle Felder aus";
      return;
    }
    let book = "Glaube für Anfänger";
    if (this.isFlyer) {
      book = "Glaube für Anfänger (Flyer)";
    }
    if (this.isAdventskalender) {
      book = "Glaube für Anfänger (Adventskalender)";
    }
    axios.post("https://bestellung.wersglaubt.at/order.php", {
      "token": token,
      "books": book,
      "email": "bestellung@wersglaubt.at",
      "first_name": this.firstName,
      "last_name": this.lastName,
      "street": this.street,
      "zip": this.zip,
      "city": this.city,
      "country": this.country,
      "source": "wersglaubt.at",
    }).then((response) => {
      this.submitted = true;
    }).catch((err) => {
      this.error = "Ein unbekannter Fehler ist aufgetreten. Bitte senden Sie Ihre Anfrage per Mail an <!--<a href='mailto:kontakt@wersglaubt.at?subject=WERSGLAUBT.AT Anfrage&body=" + this.text + "'>-->kontakt[AT]wersglaubt.at</a>. Danke für Ihr Verständnis!";
      console.error(err);
    });
  }

  get isValid() {
    return this.$data.formValid;
  }

  get isFlyer() {
    return this.$route.query.bestellen === "GfA";
  }

  get isAdventskalender() {
    return this.$route.query.s === "a";
  }

}
</script>
<style scoped lang="scss">
@import "@/stylesheets/Christmas.scss";

.orderContainer {

  .description {
    text-align: left;
    font-weight: 300;

    h3 {
      font-variant: normal;
      font-weight: 300;
      font-size: 28px;
      margin-bottom: 10px;
    }

    .author {
      font-size: 14px;
      margin-bottom: 25px;
    }

    .coverContainer {
      display: flex;

      .bookText {
        width: auto;
        display: inline-block;
        padding-right: 30px;
      }

      .cover {
        display: inline-block;
        height: 250px;
        transform: translateY(-50px);
        margin-bottom: -50px;
      }

      @media screen and (max-width: 680px) {
        display: flex;
        flex-wrap: wrap;

        .cover {
          order: 1;
          transform: none;
          margin: 0 auto;
        }

        .bookText {
          order: 2;
          margin-top: 25px;
        }

      }
    }

  }

  .orderDetailsButton {
    margin-top: 25px;
  }

  .order {
    max-height: 90vh;
    overflow-y: scroll;
    width: 800px;
    max-width: 90vw;
    overscroll-behavior: contain;

    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2500;
    padding: 30px;
    box-sizing: border-box;

    background-color: white;

    font-size: 20px;

    .closeIcon {
      position: absolute;
      top: 15px;
      right: 15px;
      height: 15px;

      &:hover {
        cursor: pointer;
      }
    }

    .data {
      padding: 20px;
    }

    .submitButton {
      margin-top: 15px;

      &[disabled="disabled"] {
        $color: grey;

        color: $color;

        border-color: $color;
        pointer-events: none;

        &:hover {
          background-color: white;
          cursor: not-allowed;
        }
      }
    }

  }

  .overlay {
    position: fixed;
    z-index: 2000;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.flex {
  padding-left: 5px;
  padding-right: 5px;
}

</style>

<style lang="scss">

.orderContainer {
  label {
    font-variant: unset !important;
    font-variant-caps: unset !important;
    font-weight: 400 !important;
    overflow-wrap: break-spaces;

    max-width: 90vw;
    margin-right: 0;
    white-space: normal;

    p {
      padding-left: 15px;
      width: 100%;
      overflow-wrap: break-word;

      a {
        display: inline;
      }
    }
  }

  .v-btn {
    &:not([disabled="disabled"]) {
      .v-btn__content {
        color: white;
      }
    }
  }

  input[type="text"] {
    padding: 0;
  }
}

.makeScrollable {
  -webkit-overflow-scrolling: touch;
}

.data {
  label {
  }
}

</style>
